import React from "react";
import Login from "../features/auth/component/Login";
import Footer from "./Footer";

function LoginPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <Login></Login>
      <Footer />
    </div>
  );
}

export default LoginPage;
